const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Masterclass Importer Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} ManageTracks the resource defined to get and set Tracks data
 */
app.directive('masterclassImporter', ['Application', 'ContentIntegrations', function (Application, ContentIntegrations) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      onImport: '&'
    },
    template: require('../../templates/directives/masterclass-importer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      self.loading = false;
      self.searchTerm = '';
      self.page = 1;
      self.perPage = 20;
      self.nextAvailable = false;
      self.prevAvailable = false;
      self.content = [];
    
      self.selectContent = function(content) {
        content.vendor = 'masterclass';
        content.course = content.id;
        $scope.onImport({item: content});
        Application.scrollTop();
      };

      let delayedSearch;
      self.updateSearch = function() {
        if (!self.searchTerm.length) {
          self.content = [];
          return;
        }

        if (self.searchTerm.length < 2) {
          return;
        }

        clearTimeout(delayedSearch);
        delayedSearch = setTimeout(async () => {
          self.page = 1;
          await self.load();
          $scope.$apply();
        }, 350);
      };

      self.changePage = async function (type) {
        if (type === 'next') {
          if (self.content.length < self.perPage) {
            return;
          }
          self.page++;
          await self.load();
          $scope.$apply();
          return;
        }

        if (type === 'prev') {
          if (self.page < 2) {
            return;
          }
          self.page--;
          await self.load();
          $scope.$apply();
          return;
        }

      };

      self.load = async function () {
        const options = {
          "page[offset]": (self.page - 1) * self.perPage,
          "page[limit]": self.perPage,
          q: self.searchTerm || ''
        };

        self.content = [];
        self.loading = true;
        const results = await ContentIntegrations.searchContent({name: 'masterclass'}, options).$promise;
        self.content = results.content;
        self.nextAvailable = self.content.length === self.perPage;
        self.prevAvailable = self.page > 1;
        self.loading = false;

      };

    }],
    controllerAs: 'mc'
  }
}]);